import flatten from 'lodash.flattendepth';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import { Query } from 'react-apollo';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import getOffers from '../../src/apollo/graphql/offer/getOffers';
import createContext from '../../src/utils/format/createContext';
import { Button, WrapperButton } from '../../src/components/Button';
import { Container } from '../../src/components/Grid';
import { Offer, Section } from '../../src/components/Layout';
import { SubTitle, Title } from '../../src/components/Title';
import { media, sizes } from '../../src/styles/media';
import routes from '../../conf/routes';
import ButtonWithLine from '../../src/components/Button/ButtonWithLine';
import CardWithImageInArc from '../../src/components/Card/CardWithImageInArc';

const OfferSlidesCarousel = dynamic(
  import('../../src/components/Carousel/OfferSlidesCarousel'),
  {
    // eslint-disable-next-line react/display-name
    loading: () => <div />,
    ssr: false
  }
);

const ButtonWrapper = styled.div`
  margin-top: 60px;
`;

const activeFilters = filters => {
  return Object.values(filters).map(filter =>
    Object.keys(filter).filter(f => filter[f])
  );
};

const filterOffers = filters => {
  return flatten(activeFilters(filters));
};

const activeOffers = filters => offers => {
  return offers.filter(offer =>
    filters.includes(
      offer.shop && offer.shop.category_id
        ? offer.shop.category_id.toString()
        : null
    )
  );
};

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

class Offers extends React.PureComponent {
  render() {
    const { filters, i18n, t } = this.props;
    const activeFilters = filterOffers(filters);
    const setActiveOffers = activeOffers(activeFilters);
    return (
      <Query
        query={getOffers}
        variables={{ orderBy: 'createdAt_DESC' }}
        context={createContext(i18n.language)}
      >
        {({ loading, error, data }) => {
          if (!loading && !error && data && data.getOffers) {
            const offers = data.getOffers;
            const activeOffers = setActiveOffers(offers);
            return (
              activeOffers.length > 0 && (
                <Section inverse>
                  <Container>
                    <Fade up>
                      <Title slider>{t('common:home.offers.title')}</Title>
                    </Fade>
                    {/* <Wrapper>
                      <Fade up>
                        <SliderComponentWithNoSSR
                          autoplay={false}
                          autoplaySpeed={5000}
                          slidesToShow={3}
                          slidesToScroll={3}
                          infinite={true}
                          dots={true}
                          responsive={[
                            {
                              breakpoint: sizes.desktop - 1,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                              }
                            },
                            {
                              breakpoint: sizes.tablet - 1,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                              }
                            }
                          ]}
                          unslick={activeOffers.length > 1 ? false : true}
                        >
                          {activeOffers.map(
                            offer =>
                              offer.shop &&
                              offer.detail && (
                                <CardWrapper key={offer.id}>
                                  <CardWithImageInArc
                                    center
                                    card={{
                                      title: offer.detail.title,
                                      description: offer.detail.description,
                                      date: offer.detail.offer_date,
                                      image: {
                                        url: offer.image
                                      },
                                      logo: {
                                        url: offer.shop.logo2Desk
                                      },
                                      ctaLeft: {
                                        label: t('common:brands.cta.offers'),
                                        url: `${t(
                                          'common:brands.navigation.brands'
                                        )}/${offer?.shop?.type ||
                                          'unknown'}/${offer?.shop?.category
                                          ?.detail?.slug || 'uncategorized'}/${
                                          offer.shop.slug
                                        }`
                                      }
                                    }}
                                    fullHeight
                                  />
                                </CardWrapper>
                              )
                          )}
                        </SliderComponentWithNoSSR>
                        <ButtonWithLine
                          href={routes.offers.langs[i18n.language]}
                        >
                          {t('common:home.offers.button')}
                        </ButtonWithLine>
                      </Fade>
                    </Wrapper> */}

                    <OfferSlidesCarousel slides={offers} isMobile={false} />
                    <ButtonWrapper>
                      <ButtonWithLine href={routes.offers.langs[i18n.language]}>
                        {t('common:home.offers.button')}
                      </ButtonWithLine>
                    </ButtonWrapper>
                  </Container>
                </Section>
              )
            );
          }

          return null;
        }}
      </Query>
    );
  }
}

Offers.propTypes = {
  type: PropTypes.string,
  category: PropTypes.string,
  filters: PropTypes.object
};

export default translate()(Offers);
